// Profile cache utility to prevent duplicate API calls

const CACHE_KEY = 'user_profile_cache';
const CACHE_EXPIRY_MS = 5 * 60 * 1000; // 5 minutes

interface CachedProfile {
  data: any;
  timestamp: number;
}

export const profileCache = {
  get: (): any | null => {
    try {
      const cached = sessionStorage.getItem(CACHE_KEY);
      if (!cached) return null;

      const { data, timestamp }: CachedProfile = JSON.parse(cached);
      const now = Date.now();

      // Check if cache is expired
      if (now - timestamp > CACHE_EXPIRY_MS) {
        sessionStorage.removeItem(CACHE_KEY);
        return null;
      }

      return data;
    } catch (error) {
      console.error('Failed to read profile cache:', error);
      return null;
    }
  },

  set: (data: any): void => {
    try {
      const cached: CachedProfile = {
        data,
        timestamp: Date.now(),
      };
      sessionStorage.setItem(CACHE_KEY, JSON.stringify(cached));
    } catch (error) {
      console.error('Failed to set profile cache:', error);
    }
  },

  clear: (): void => {
    try {
      sessionStorage.removeItem(CACHE_KEY);
    } catch (error) {
      console.error('Failed to clear profile cache:', error);
    }
  },
};
